"use client";

export const GridHelper = () => (
  <div className='dev-tools'>
    <button
      aria-label='Toggle grid'
      className='dev-tools-toggle'
      onClick={e => {
        // @ts-expect-error
        e.target.nextElementSibling.hidden = !e.target.nextElementSibling.hidden;
      }}
      type='button'
    />
    <div className='dev-tools-grid' hidden />
  </div>
);
